/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Views_ChangesInputs */

const en_views_changes = /** @type {(inputs: Views_ChangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unsaved changes to ${i?.name}`)
};

const de_views_changes = /** @type {(inputs: Views_ChangesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ungespeicherte Änderungen an ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Unsaved changes to {name}" |
*
* @param {Views_ChangesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_changes = /** @type {((inputs: Views_ChangesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_ChangesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_changes(inputs)
	return en_views_changes(inputs)
});